<mat-toolbar class="bg-beige-tricon">
  <span class="whitespace-normal text-center">
    Pending Maintenance Request
  </span>
</mat-toolbar>

<mat-dialog-content>
  <p>You started creating a maintenance request. Would you like to complete the request or discard it?</p>
</mat-dialog-content>

<mat-dialog-actions class="w-full flex flex-col justify-center">
  <button mat-flat-button class="my-2 w-full ml-0" color="primary" mat-dialog-close
    mat-dialog-close="COMPLETE_REQUEST">COMPLETE
    REQUEST</button>
  <button mat-flat-button class="my-2 w-full ml-0" color="primary" mat-dialog-close
    mat-dialog-close="DISCARD">DISCARD</button>
  <button mat-flat-button class="my-2 w-full ml-0" color="primary" mat-dialog-close
    mat-dialog-close="CANCEL">CANCEL</button>
</mat-dialog-actions>